import { Component, OnInit } from '@angular/core';
import { ScheduleTypeMasterComponent } from '../schedule-type-master/schedule-type-master.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfigurationService } from 'app/masters/configuration/configuration.service';
import { Observable, Subject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { scheduleTypemasterAddedModal, scheduleTypemasterModal } from '../schedule-master.model';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DatePipe } from '@angular/common';
import { AuthService } from 'app/auth/auth.service';
import * as moment from 'moment';
import { DynamicHelpListComponent } from 'app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';


@Component({
  selector: 'app-opd-schedule-manager',
  templateUrl: './opd-schedule-manager.component.html',
  styleUrls: ['./opd-schedule-manager.component.scss']
})
export class OpdScheduleManagerComponent implements OnInit {
  columnNames: string[] = ['From ApptTime', 'To ApptTime', 'Interval(Minute)', 'Max Slot Limit', 'Block', 'isActive'];
  destroyshedulemaster$: Subject<boolean> = new Subject<boolean>();
  private branchList: any = [];
  private doctorList: any = [];
  private weektypeList: any = [];
  enabledisablebtn: boolean = true;
  selectedRadio: boolean = true;
  editCache: any = {};
  color: any;
  _value: number = 0;
  _hourvalue: number = 0;
  _step: number = 1;
  _min: number = 0;
  _max: number = 60;
  _hourmax: number = 12;
  _wrap: boolean = false;
  intervalMinuitArray = [{ "minute": 5 }, { "minute": 10 }, { "minute": 15 }, { "minute": 20 }, { "minute": 25 }, { "minute": 30 },
  { "minute": 35 }, { "minute": 40 }, { "minute": 45 }, { "minute": 50 }, { "minute": 55 }, { "minute": 60 }, { "minute": 75 }, { "minute": 90 }
  ]

  private filteredBranchArray: Observable<any[]>;
  private filteredaddBranchArray: Observable<any[]>;
  private filterdoctorArray: Observable<any[]>;
  private filterweekArray: Observable<any[]>;
  private filtescheduleTypeArray: Observable<any[]>;
  private filtescheduleGroupArray: Observable<any[]>;
  private filtersubsepceialArray: Observable<any[]>;
  private filterDrsubsepceialArray: Observable<any[]>;
  private timeFormatcheck: any;
  private tableListArrayData = []
  BranchId: FormControl;
  BranchIdadd: FormControl;
  specilitylID: FormControl;
  drspecilitylID: FormControl;
  doctorId: FormControl;
  weekId: FormControl;
  scheduleGroupID: FormControl;
  scheduleTypeID: FormControl;
  selectedColumnName: string | null = null;
  inputValue: any = '';
  selectedradioType: string = 'true';
  selectedUserType: string = "DOCTOR";

  form_Date: any;
  to_Date: any;
  private scheduleMastermodel: scheduleTypemasterModal = {}
  private scheduleMasteraddmodel: scheduleTypemasterAddedModal = {}
  constructor(private dialog: MatDialog,
    private configurationService: ConfigurationService,
    private dashboardService: DashboardService,
    private datePipe: DatePipe,
    public authService: AuthService
  ) {

  }

  ngOnInit(): void {
    this.BranchId = new FormControl();
    this.BranchIdadd = new FormControl();
    this.specilitylID = new FormControl();
    this.drspecilitylID = new FormControl();
    this.doctorId = new FormControl();
    this.weekId = new FormControl();
    this.scheduleGroupID = new FormControl()
    this.scheduleTypeID = new FormControl();

    this.getBranchList();
    this.getDoctorBrach();
    this.getNameByType();
    this.getscheduleData();
    this.getSpecilitylistData(0)
    this.getDaysBetweenDates();
    this.timeFormatcheck = "AM";
    this.scheduleMastermodel.formDate = this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd");
    this.scheduleMastermodel.toDate = this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd");

    this.form_Date = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
    this.to_Date = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
  }

  daysArray: any = [];
  getDaysBetweenDates() {
    if (!this.form_Date || !this.to_Date) return;

    let startDate = new Date(this.form_Date);
    let endDate = new Date(this.to_Date);

    while (startDate <= endDate) {
      let dayName = startDate.toLocaleDateString('en-US', { weekday: 'long' });
      this.daysArray.push(dayName);
      startDate.setDate(startDate.getDate() + 1);
    }
  }

  getBranchList() {
    this.configurationService.getBranchMaster().subscribe(data => {
      this.branchList = data;
      this.branchControlladd();
      this.branchControll();
    });
  }

  branchControll() {
    this.BranchId = new FormControl();
    this.filteredBranchArray = this.BranchId.valueChanges
      .pipe(
        startWith(''),
        map(country => country ? this.filterBranchfunction(country) : this.branchList.slice())
      );
  }

  filterBranchfunction(name: string) {
    return this.branchList.filter(item =>
      item.branchName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getbranchObj(e) {
    var val = e.option.id;
    this.scheduleMastermodel.FK_BranchId = val
  }

  branchControlladd() {
    this.BranchIdadd = new FormControl();
    this.filteredaddBranchArray = this.BranchIdadd.valueChanges
      .pipe(
        startWith(''),
        map(country => country ? this.filterBranchaddfunction(country) : this.branchList.slice())
      );
  }

  filterBranchaddfunction(name: string) {
    return this.branchList.filter(item =>
      item.branchName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getbranchaddObj(e) {
    var val = e.option.id;
    this.scheduleMasteraddmodel.FK_BranchId = val
    if (this.speciId) {
      this.drsbysubspecilitylist(this.scheduleMasteraddmodel.FK_BranchId, this.speciId)
    }
  }

  getDoctorBrach() {
    this.dashboardService.getall_doctors().pipe(takeUntil(this.destroyshedulemaster$)).subscribe((res) => {
      this.doctorList = res
      this.doctorControll()
    })

  }

  doctorControll() {
    this.doctorId = new FormControl();
    this.filterdoctorArray = this.doctorId.valueChanges
      .pipe(
        startWith(''),
        map(item => item ? this.filterDrfunction(item) : this.doctorList.slice())
      );
  }

  filterDrfunction(name: string) {
    return this.doctorList.filter(item =>
      item.userName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getdoctorObj(e) {
    var val = e.option.id;
    this.scheduleMastermodel.FK_DoctorId = val
  }

  cleardoctorId() {
    if (!this.scheduleMastermodel.doctorName || this.scheduleMastermodel.doctorName.toString().trim() === '') {
      this.scheduleMastermodel.FK_DoctorId = null;
    }
  }

  getNameByType() {
    this.configurationService.GetNameByType().subscribe(data => {
      this.weektypeList = data;
      this.weekControll();
    });
  }



  weekControll() {
    this.weekId = new FormControl();
    this.filterweekArray = this.weekId.valueChanges
      .pipe(
        startWith(''),
        map(item => item ? this.filterweekfunction(item) : this.weektypeList.slice())
      );
  }

  filterweekfunction(name: string) {
    return this.weektypeList.filter(item =>
      item.name.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getweekObj(e) {
    var val = e.option.id;
    this.scheduleMastermodel.WeekDayId = val
  }

  drsubsepceialList: any = []
  subsepceialList: any = [];

  drsbysubspecilitylist(branchid, id) {
    this.configurationService.get_drsbysubspecilityId(branchid, id).pipe(takeUntil(this.destroyshedulemaster$)).subscribe((x: any) => {
      this.drsubsepceialList = x
      this.drSpecilityControll();
    });
  }

  drSpecilityControll() {
    this.drspecilitylID = new FormControl();
    this.filterDrsubsepceialArray = this.drspecilitylID.valueChanges
      .pipe(
        startWith(''),
        map(item => item ? this.drfilterSpecility(item) : this.drsubsepceialList.slice())
      );
  }

  drfilterSpecility(name: string) {
    return this.drsubsepceialList.filter(item =>
      item.userName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  drSpecilityheduleTypeObj(e) {
    var val = e.option.id;
    this.scheduleMasteraddmodel.doctorId = val
  }


  getSpecilitylistData(id) {
    this.configurationService.getSpeciltiyList(id).pipe(takeUntil(this.destroyshedulemaster$)).subscribe((x: any) => {
      this.subsepceialList = [];
      this.subsepceialList = x;
      this.SpecilityControll();
    });
  }


  SpecilityControll() {
    this.specilitylID = new FormControl();
    this.filtersubsepceialArray = this.specilitylID.valueChanges
      .pipe(
        startWith(''),
        map(item => item ? this.filterSpecility(item) : this.subsepceialList.slice())
      );
  }

  filterSpecility(name: string) {
    return this.subsepceialList.filter(item =>
      item.subSpecialityName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }
  speciId: any
  SpecilityheduleTypeObj(e) {
    var val = e.option.id;
    this.speciId = val
    this.scheduleMasteraddmodel.pK_SubSpecialityId = val
    this.drsbysubspecilitylist(this.scheduleMasteraddmodel.FK_BranchId, val)
  }


  getarraydataList: any = []
  Sheduleobject: any
  addNewRow() {
    const isEditing = this.getarraydataList.some((row) => row.edit === true);
    if (isEditing) {
      this.dashboardService.openSnackBar('You Cannot Add More Than One Row', 'OK');
      return;
    }
    this.Sheduleobject = {
      scheduleGroup: null,
      scheduleType: null,
      FK_ScheduleTypeId: null,
      fromApptTime: '',
      toApptTime: '',
      IntervalMinuit: null,
      MaxLimitSlot: null,
      edit: true
    };
    this.getarraydataList.push(this.Sheduleobject);
    this.updateEditDrCache();
  }
  schedulenniqeGroupList: any
  scheduleGroupList: any;
  scheduleTypeList: any;
  scheduleallList: any
  getscheduleData() {
    this.configurationService.GetScheduleTypeMaster()
      .pipe(takeUntil(this.destroyshedulemaster$))
      .subscribe(
        (item: any[]) => {
          this.scheduleallList = item;
          // this.schedulenniqeGroupList = [
          //   ...new Set(item.map(x => x.scheduleGroup))
          // ].map(scheduleGroup => ({ scheduleGroup }));

          this.scheduleGroupList = item.map(x => ({
            scheduleGroup: x.scheduleGroup,
          }));

          let seen = new Set();
          this.schedulenniqeGroupList = this.scheduleGroupList.filter(x => {
            if (seen.has(x.scheduleGroup)) {
              return false;
            } else {
              seen.add(x.scheduleGroup);
              return true;
            }
          })
          // this.scheduleTypeList = item.map(x => x.scheduleType); 
          this.scheduleTypeList = item.map(x => ({
            scheduleType: x.scheduleType,
            pK_ScheduleTypeId: x.pK_ScheduleTypeId
          }));
          this.scheduleTypeControll()
          this.scheduleGroupControll()
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  shedulegroupname: any
  filteredScheduleTypes: any = [];
  scheduleGroupsel(e) {
    // this.shedulegroupname = e.value
    this.shedulegroupname = e.value;

    this.filteredScheduleTypes = this.scheduleallList
      .filter(item => item.scheduleGroup === this.shedulegroupname)
      .map(item => ({
        scheduleType: item.scheduleType,
        pK_ScheduleTypeId: item.pK_ScheduleTypeId
      }));
  }

  scheduleTypeControll() {
    this.scheduleTypeID = new FormControl();
    this.filtescheduleTypeArray = this.scheduleTypeID.valueChanges
      .pipe(
        startWith(''),
        map(item => item ? this.filterscheduleType(item) : this.scheduleTypeList.slice())
      );
  }

  filterscheduleType(name: string) {
    return this.scheduleTypeList.filter(item =>
      item.scheduleType.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  scheduleTypeObj(e) {
    var val = e.option.id;
    this.scheduleMastermodel.FK_ScheduleTypeId = val
  }

  scheduleGroupControll() {
    this.scheduleGroupID = new FormControl();
    this.filtescheduleGroupArray = this.scheduleGroupID.valueChanges
      .pipe(
        startWith(''),
        map(item => item ? this.filterscheduleGroup(item) : this.scheduleGroupList.slice())
      );
  }

  filterscheduleGroup(name: string) {
    return this.scheduleGroupList.filter(item =>
      item.scheduleGroup.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  scheduleGroupObj(e) {
    var val = e.option.value;
    this.scheduleMastermodel.scheduleGroup = val
  }

  helpListPOpup(parameter) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',
      data: {
        parametertype: parameter
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroyshedulemaster$)).subscribe(result => {
      if(result){
        this.scheduleMasteraddmodel.BlockName = result;
      }
    });
  }

onFromDateChange() {
  if (this.to_Date && this.to_Date < this.form_Date) {
    this.to_Date = null;
  }
}

  formatTime(time: string | null | undefined): string {
    if (!time) {
      return '';
    }
    return moment(time, "HH:mm a").format("hh:mm A");
  }

  saveSchedule(event) {
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    setTimeout(function () {
      button.removeAttribute('disabled');
    }, 2000);
    this.getDaysBetweenDates();
    if (!this.scheduleMasteraddmodel.FK_BranchId) {
      this.dashboardService.openSnackBar("Please Select Branch Name", "OK")
      return;
    }

    if (!this.scheduleMasteraddmodel.subSpecialityName) {
      this.dashboardService.openSnackBar("Please Select Speciality Name", "OK")
      return;
    }

    if (!this.form_Date) {
      this.dashboardService.openSnackBar("Please Select From Date", "OK")
      return;
    }

    if (!this.to_Date) {
      this.dashboardService.openSnackBar("Please Select To Date", "OK")
      return;
    }

    if (this.form_Date > this.to_Date) {
      this.dashboardService.openSnackBar("From Date should not be greater than To Date", "OK");
      return;
    }

    const branchInput = this.scheduleMasteraddmodel.branchName?.trim();
    if (branchInput) {
      const isInputValid = this.branchList.some(item => item.branchName?.toLowerCase() === branchInput.toLowerCase());
      if (!isInputValid) {
        this.dashboardService.openSnackBar("Please Select Correct Branch Name", "OK");
        return;
      }
    }

    const speInput = this.scheduleMasteraddmodel.subSpecialityName?.trim();
    if (speInput) {
      const isInputValid = this.subsepceialList.some(item => item.subSpecialityName?.toLowerCase() === speInput.toLowerCase());
      if (!isInputValid) {
        this.dashboardService.openSnackBar("Please Select Correct Speciality Name", "OK");
        return;
      }
    }

    const drInput = this.scheduleMasteraddmodel.doctorName?.trim();
    if (drInput) {
      const isInputValid = this.drsubsepceialList.some(item => item.userName?.toLowerCase() === drInput.toLowerCase());
      if (!isInputValid) {
        this.dashboardService.openSnackBar("Please Select Correct Doctor Name", "OK");
        return;
      }
    }

    if (this.Fk_DoctorIdarray.length == 0) {
      this.dashboardService.openSnackBar("Please Select Username from table", "OK");
      return;
    }

    if (this.WeekDayIds.length == 0) {
      this.dashboardService.openSnackBar("Please Select Weekdays from table", "OK");
      return;
    }

    if (this.getarraydataList.length == 0) {
      this.dashboardService.openSnackBar("Please Add the Schedule ", "OK");
      return;
    }

    for (let item of this.getarraydataList) {
      if (!item.scheduleGroup) {
        this.dashboardService.openSnackBar("Please Select Schedule Group", "OK");
        return;
      }
      if (!item.scheduleType) {
        this.dashboardService.openSnackBar("Please Select Schedule Type ", "OK");
        return;
      }
      if (!item.IntervalMinuit) {
        this.dashboardService.openSnackBar("Please Enter Interval", "OK");
        return;
      }
      if (!item.fromApptTime) {
        this.dashboardService.openSnackBar("Please Enter From Time", "OK");
        return;
      }
      if (!item.toApptTime) {
        this.dashboardService.openSnackBar("Please Enter To Time", "OK");
        return;
      }

      if (item.fromApptTime > item.toApptTime) {
        this.dashboardService.openSnackBar("From Time should not be greater than To Time", "OK");
        return;
      }

      if (!item.MaxLimitSlot) {
        this.dashboardService.openSnackBar("Please Enter the Slot", "OK");
        return;
      }

    }

    let uniqueGroups = new Set();
    let isDuplicate = this.getarraydataList.some(item => {
      if (uniqueGroups.has(item.scheduleGroup)) {
        return true;
      }
      uniqueGroups.add(item.scheduleGroup);
      return false;
    });

    if (isDuplicate) {
      this.dashboardService.openSnackBar("Duplicate Schedule Group Not Allowed", "OK");
      return;
    }
    let chosenWeekdays = this.weektypeList.filter(item => item.isChecked)
      .map(item => item.name); // Extract names
    let isValid = chosenWeekdays.some(day => this.daysArray.includes(day));

    if (!isValid) {
      this.dashboardService.openSnackBar("The selected weekdays do not match any days in the selected date range", "OK");
      return;
    }
    let payload =
    {
      "OpdScheduleListDto": {
        "PK_ScheduleId": 0,
        "FK_BranchId": this.scheduleMasteraddmodel.FK_BranchId,
        "FromDate": this.form_Date,
        "ToDate": this.to_Date,
        "BlockName": this.scheduleMasteraddmodel.BlockName,
        "IsActive": this.scheduleMasteraddmodel.IsActive ? this.scheduleMasteraddmodel.IsActive : false,
        "Fk_DoctorId": this.Fk_DoctorIdarray,
        "WeekDayIds": this.WeekDayIds,
        "OPDScDto": this.getarraydataList.map(item => ({
          "FK_ScheduleTypeId": item.FK_ScheduleTypeId,
          "FromApptTime": this.formatToApiTime(item.fromApptTime),
          "ToApptTime": this.formatToApiTime(item.toApptTime),
          "IntervalMinuit": item.IntervalMinuit,
          "MaxLimitSlot": item.MaxLimitSlot
        })),
        "IsEdit": false,
        "IsDelete": false
      }
    }
    this.configurationService.InsertDoctorScheduleMasterOpd(payload).pipe(takeUntil(this.destroyshedulemaster$)).subscribe((res) => {
      if (res['statusCode'] == 1) {
        this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
        this.cleareaddShedule();
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  cleareaddShedule() {
    this.scheduleMasteraddmodel.FK_BranchId = null;
    this.scheduleMasteraddmodel.branchName = null;
    this.scheduleMasteraddmodel.subSpecialityName = null;
    this.scheduleMasteraddmodel.pK_SubSpecialityId = null;
    this.form_Date = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
    this.to_Date = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
    this.scheduleMasteraddmodel.doctorName = null;
    this.scheduleMasteraddmodel.doctorId = null;
    this.scheduleMasteraddmodel.BlockName = null;
    this.scheduleMasteraddmodel.IsActive = null;
    this.drsubsepceialList = [];
    this.getarraydataList = [];
    this.ischeck = false;
    this.weektypeList.forEach(item => item.isChecked = false);
    this.WeekDayIds = [];
  }

  WeekDayIds: any = [];
  ischeck: any
  toggleWeekday(itemm: any, isChecked: boolean) {
    if (isChecked) {
      itemm.isChecked = isChecked
      if (!this.WeekDayIds.includes(itemm.pK_Id)) {
        this.WeekDayIds.push(itemm.pK_Id);
      }
    } else {
      this.WeekDayIds = this.WeekDayIds.filter(item => item !== itemm.pK_Id);
    }

  }

  Fk_DoctorIdarray: any = [];
  toggleFk_DoctorId(id: number, isChecked: boolean) {
    if (isChecked) {
      if (!this.Fk_DoctorIdarray.includes(id)) {
        this.Fk_DoctorIdarray.push(id);
      }
    } else {
      this.Fk_DoctorIdarray = this.Fk_DoctorIdarray.filter(item => item !== id);
    }
  }


  objScheduleTypes(e, index) {
    const selectedloc = this.filteredScheduleTypes.find(
      (loc) => loc.scheduleType == e.value
    );
    this.getarraydataList[index].FK_ScheduleTypeId = selectedloc.pK_ScheduleTypeId
  }

  ShowRecord() {
    if (!this.scheduleMastermodel.FK_BranchId) {
      this.dashboardService.openSnackBar("Please Select Branch First", "OK")
      return;
    }
    if (!this.scheduleMastermodel.formDate) {
      this.dashboardService.openSnackBar("Please Select From Date", "OK")
      return;
    }

    if (!this.scheduleMastermodel.toDate) {
      this.dashboardService.openSnackBar("Please Select To Date", "OK")
      return;
    }

    if (!this.scheduleMastermodel.FK_ScheduleTypeId) {
      this.dashboardService.openSnackBar("Please Select Schedule Type", "OK")
      return;
    }
    const fromDate = new Date(this.scheduleMastermodel.formDate);
    const toDate = new Date(this.scheduleMastermodel.toDate);

    if (fromDate > toDate) {
      this.dashboardService.openSnackBar("From Date should not be greater than To Date", "OK");
      return;
    }

    const branchInput = this.scheduleMastermodel.branchName?.trim();
    if (branchInput) {
      const isInputValid = this.branchList.some(item => item.branchName?.toLowerCase() === branchInput.toLowerCase());
      if (!isInputValid) {
        this.dashboardService.openSnackBar("Please Select Correct Branch Name", "OK");
        return;
      }
    }
    const doctorInput = this.scheduleMastermodel.doctorName?.trim();
    if (doctorInput) {
      const isInputValid = this.doctorList.some(item => item.userName?.toLowerCase() === doctorInput.toLowerCase());
      if (!isInputValid) {
        this.dashboardService.openSnackBar("Please Select Correct Doctor Name", "OK");
        return;
      }
    }
    const scheduleGroupInput = this.scheduleMastermodel.scheduleGroup?.trim();
    if (scheduleGroupInput) {
      const isInputValid = this.scheduleGroupList.some(item => item.scheduleGroup?.toLowerCase() === scheduleGroupInput.toLowerCase());
      if (!isInputValid) {
        this.dashboardService.openSnackBar("Please Select Correct Schedule Group Name", "OK");
        return;
      }
    }

    const scheduleTypeInput = this.scheduleMastermodel.scheduleType?.trim();
    if (scheduleTypeInput) {
      const isInputValid = this.scheduleTypeList.some(item => item.scheduleType?.toLowerCase() === scheduleTypeInput.toLowerCase());
      if (!isInputValid) {
        this.dashboardService.openSnackBar("Please Select Correct Schedule Type Name", "OK");
        return;
      }
    }

    const weeknameInput = this.scheduleMastermodel.weekname?.trim();
    if (weeknameInput) {
      const isInputValid = this.weektypeList.some(item => item.name?.toLowerCase() === weeknameInput.toLowerCase());
      if (!isInputValid) {
        this.dashboardService.openSnackBar("Please Select Correct Week Day Name", "OK");
        return;
      }
    }

    let PayLoad =
    {
      "FK_BranchId": this.scheduleMastermodel.FK_BranchId,
      "FK_DoctorId": this.scheduleMastermodel.FK_DoctorId,
      "FromDate": this.scheduleMastermodel.formDate,
      "ToDate": this.scheduleMastermodel.toDate,
      "FK_ScheduleTypeId": this.scheduleMastermodel.FK_ScheduleTypeId,
      "ScheduleGroup": this.scheduleMastermodel.scheduleGroup,
      "WeekDayId": this.scheduleMastermodel.WeekDayId,
      "ScheduleUserType": this.selectedUserType
    }
    this.configurationService.GetDoctorOPDScheduleMaster(PayLoad).pipe(takeUntil(this.destroyshedulemaster$)).subscribe((res) => {
      if (res.length > 0) {
        this.tableListArrayData = res
        this.enabledisablebtn = false;
      } else {
        this.dashboardService.openSnackBar("No Record Found", "OK");
        this.tableListArrayData = [];
        this.enabledisablebtn = true;
      }
    })
  }

  columnMapping = {
    'From ApptTime': 'fromApptTime',
    'To ApptTime': 'toApptTime',
    'Interval(Minute)': 'intervalMinuit',
    'Max Slot Limit': 'maxLimitSlot',
    'Block': 'blockName',
    'isActive': 'isActive'
  };
  updateColumnValues() {
    if (!this.inputValue) {
      this.dashboardService.openSnackBar('Please enter the value', 'OK');
      return;
    }
    const colKey = this.columnMapping[this.selectedColumnName];
    if (!colKey || this.tableListArrayData.length == 0) return;
    for (let row of this.tableListArrayData) {
      if (colKey == 'isActive') {
        row[colKey] = this.inputValue == 'true' ? true : false;
      } else {
        row[colKey] = this.inputValue
      }
    }
    this.closeEditColumnWiseModal();
  }

  onHeaderChange(item: any, isChecked: boolean) {
    item.isActive = isChecked;
  }
  //Discharge Time
  colindex: number = -1;
  checknursemedTranid: number = 0;
  ChangetimeName
  admissionTime(type: any, index?: number) {
    this.ChangetimeName = type;
    this._value = 0;
    this._hourvalue = 0;
    this.colindex = index;
    document.getElementById("timeModal").style.display = "block";
  }
  private hourwrappedValue(hourinputValue): number {
    if (hourinputValue > this._hourmax) {
      return this._min + hourinputValue - this._hourmax;
    }

    if (hourinputValue < this._min) {
      if (this._hourmax === 60) {
        return 0;
      }

      return this._hourmax + hourinputValue;
    }

    return hourinputValue;
  }

  hoursincrementValue(step: number = 1): void {
    let hourinputValue = this._hourvalue + step;

    if (this._wrap) {
      hourinputValue = this.hourwrappedValue(hourinputValue);
    }

    this._hourvalue = hourinputValue;
  }

  setColor(color: string): void {
    this.color = color;
  }

  getColor(): string {
    return this.color;
  }

  incrementValue(step: number = 1): void {
    let inputValue = this._value + step;

    if (this._wrap) {
      inputValue = this.wrappedValue(inputValue);
    }
    this._value = inputValue;
  }

  private wrappedValue(inputValue): number {
    if (inputValue > this._max) {
      return this._min + inputValue - this._max;
    }

    if (inputValue < this._min) {
      if (this._max === 12) {
        return 0;
      }

      return this._max + inputValue;
    }

    return inputValue;
  }

  shouldDisableDecrement(inputValue: number): boolean {
    return !this._wrap && inputValue <= this._min;
  }

  shouldDisableIncrement(inputValue: number): boolean {
    return !this._wrap && inputValue >= this._max;
  }

  hourshouldDisableDecrement(hourinputValue: number): boolean {
    return !this._wrap && hourinputValue <= this._min;
  }

  hourshouldDisableIncrement(hourinputValue: number): boolean {
    return !this._wrap && hourinputValue >= this._hourmax;
  }

  changeFormat(event: any) {
    this.timeFormatcheck = event;
  }

  addTime(hr, min) {
    if (hr > 12 || min > 59 || min == null || hr == null) {
      return this.dashboardService.openSnackBar("Select Valid Time", "OK");
    } else if (hr < 1 || min < 0) {
      return this.dashboardService.openSnackBar("Select Valid Time", "OK");
    }
    let bindtimee = hr + ":" + min + " " + this.timeFormatcheck;
    // this.inputValue = bindtimee
    let bindTime = (hr < 10 ? '0' + hr : hr) + ":" + (min < 10 ? '0' + min : min);
    if (this.ChangetimeName == 1) {
      // this.tableListArrayData[this.colindex].fromApptTime = moment(bindTime["HH:mm"]).format("h:mm A");
      this.tableListArrayData[this.colindex].fromApptTime = bindtimee
    }
    if (this.ChangetimeName == 2) {
      // this.tableListArrayData[this.colindex].toApptTime =  moment(bindTime["HH:mm"]).format("h:mm A");
      this.tableListArrayData[this.colindex].toApptTime = bindtimee
    }
    if (this.ChangetimeName == 3) {
      // this.tableListArrayData[this.colindex].toApptTime =  moment(bindTime["HH:mm"]).format("h:mm A");
      this.getarraydataList[this.colindex].fromApptTime = bindtimee
    }
    if (this.ChangetimeName == 4) {
      // this.tableListArrayData[this.colindex].toApptTime =  moment(bindTime["HH:mm"]).format("h:mm A");
      let fromTime = moment(this.getarraydataList[this.colindex].fromApptTime, "hh:mm A");
      let toTime = moment(bindtimee, "hh:mm A");

      // Validate if 'toApptTime' is at least 'IntervalMinuit' minutes after 'fromApptTime'
      let intervalMin = this.getarraydataList[this.colindex].IntervalMinuit || 15; // Default to 30 minutes if not set
      let requiredToTime = fromTime.add(intervalMin, 'minutes');

      if (toTime.isBefore(requiredToTime)) {
        return this.dashboardService.openSnackBar("To Appt Time should be at least " + intervalMin + " minutes after From Appt Time", "OK");
      }

      this.getarraydataList[this.colindex].toApptTime = bindtimee;

      // this.getarraydataList[this.colindex].toApptTime = bindtimee
    }
    this.CanceladmissionTime();
  }
  CanceladmissionTime() {
    document.getElementById("timeModal").style.display = "none";
  }

  formatToApiTime(time: string): string {
    return moment(time, "hh:mm A").format("HH:mm:ss.SSSSSSS");
  }
  updateEditCache(): void {
    this.tableListArrayData.forEach((item, index) => {
      this.editCache[index] = {
        edit: false,
        data: { ...item },
      };
    });
  }

  Edit(index: number, item: any) {
    this.updateEditCache();
    this.editCache[index].edit = true;
  }

  saveedit(index: number, item: any) {
    this.editCache[index].edit = false;
  }

  updateEditDrCache() {
    this.getarraydataList.forEach((item, index) => {
      this.editCache[index] = {
        edit: item.edit || false,
        data: { ...item }
      };
    });
  }

  Editadd(index: number, item: any) {
    this.updateEditDrCache();
    this.editCache[index].edit = true;
  }

  saveeditadd(index: number, item: any) {
    item.edit = false;
    this.editCache[index].edit = false;
  }

  deleteItem(index: number) {
    this.getarraydataList.splice(index, 1);
  }

  saveAllshedule(event) {

    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    setTimeout(function () {
      button.removeAttribute('disabled');
    }, 1000);

    this.tableListArrayData.forEach((item, index) => {
      if (this.editCache[index] && this.editCache[index].edit) {
        this.editCache[index].edit = false;
      }
    });

    if (!this.scheduleMastermodel.FK_BranchId) {
      this.dashboardService.openSnackBar("Please Select Branch First", "OK")
      return;
    }

    if (!this.scheduleMastermodel.FK_ScheduleTypeId) {
      this.dashboardService.openSnackBar("Please Select Schedule Type", "OK")
      return;
    }

    if (!this.scheduleMastermodel.formDate) {
      this.dashboardService.openSnackBar("Please Select From Date", "OK")
      return;
    }

    if (!this.scheduleMastermodel.toDate) {
      this.dashboardService.openSnackBar("Please Select To Date", "OK")
      return;
    }

    const fromDate = new Date(this.scheduleMastermodel.formDate);
    const toDate = new Date(this.scheduleMastermodel.toDate);

    if (fromDate > toDate) {
      this.dashboardService.openSnackBar("From Date should not be greater than To Date", "OK");
      return;
    }

    const doctorInput = this.scheduleMastermodel.doctorName?.trim();
    if (doctorInput) {
      const isInputValid = this.doctorList.some(item => item.userName?.toLowerCase() === doctorInput.toLowerCase());
      if (!isInputValid) {
        this.dashboardService.openSnackBar("Please Select Correct Doctor Name", "OK");
        return;
      }
    }
    const scheduleGroupInput = this.scheduleMastermodel.scheduleGroup?.trim();
    if (scheduleGroupInput) {
      const isInputValid = this.scheduleGroupList.some(item => item.scheduleGroup?.toLowerCase() === scheduleGroupInput.toLowerCase());
      if (!isInputValid) {
        this.dashboardService.openSnackBar("Please Select Correct Schedule Group Name", "OK");
        return;
      }
    }

    const scheduleTypeInput = this.scheduleMastermodel.scheduleType?.trim();
    if (scheduleTypeInput) {
      const isInputValid = this.scheduleTypeList.some(item => item.scheduleType?.toLowerCase() === scheduleTypeInput.toLowerCase());
      if (!isInputValid) {
        this.dashboardService.openSnackBar("Please Select Correct Schedule Type Name", "OK");
        return;
      }
    }

    const weeknameInput = this.scheduleMastermodel.weekname?.trim();
    if (weeknameInput) {
      const isInputValid = this.weektypeList.some(item => item.name?.toLowerCase() === weeknameInput.toLowerCase());
      if (!isInputValid) {
        this.dashboardService.openSnackBar("Please Select Correct Week Day Name", "OK");
        return;
      }
    }

    var insertshedulearray = []
    this.tableListArrayData.forEach((item) => {
      insertshedulearray.push({
        "PK_ScheduleId": item.pK_ScheduleId,
        "FK_BranchId": this.scheduleMastermodel.FK_BranchId,
        "FK_ScheduleTypeId": this.scheduleMastermodel.FK_ScheduleTypeId,
        "ScheduleDate": item.scheduleDate,
        "FK_DoctorId": item.fK_DoctorId,
        "FromApptTime": this.formatToApiTime(item.fromApptTime),
        "ToApptTime": this.formatToApiTime(item.toApptTime),
        "IntervalMinuit": item.intervalMinuit ? item.intervalMinuit : 0,
        "MaxLimitSlot": item.maxLimitSlot ? item.maxLimitSlot : 0,
        "BlockName": item.blockName,
        "IsActive": item.isActive,
        "IsEdit": item.pK_ScheduleId > 0 ? true : false
      })
    })
    let payload = {
      InsertDoctorOpdScheduleMaster: insertshedulearray
    }
    this.configurationService.InsertDoctorOpdScheduleMaster(payload).pipe(takeUntil(this.destroyshedulemaster$)).subscribe((res) => {
      if (res['statusCode'] == 1) {
        this.ShowRecord();
        this.dashboardService.openSnackBar("Record Updated Successfully", "OK");
      }
      insertshedulearray = [];
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  clearedata() {
    this.tableListArrayData = [];
    this.scheduleMastermodel.FK_BranchId = null;
    this.scheduleMastermodel.FK_DoctorId = null;
    this.scheduleMastermodel.WeekDayId = null;
    this.scheduleMastermodel.FK_ScheduleTypeId = null;
    this.scheduleMastermodel.scheduleGroup = ''
    this.scheduleMastermodel.branchName = '';
    this.scheduleMastermodel.doctorName = '';
    this.scheduleMastermodel.scheduleType = '';
    this.scheduleMastermodel.weekname = '';
    this.enabledisablebtn = true;
    this.scheduleMastermodel.formDate = this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd");
    this.scheduleMastermodel.toDate = this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd");
  }

  ngOnDestroy(): void {
    this.destroyshedulemaster$.next(true);
    this.destroyshedulemaster$.unsubscribe();
    this.tableListArrayData = null;
    this.filtescheduleGroupArray = null
    this.filtescheduleTypeArray = null
    this.scheduleTypeList = null
    this.scheduleGroupList = null
    this.scheduleTypeList = null
    this.filterweekArray = null
    this.filterdoctorArray = null
    this.doctorList = null
    this.filteredBranchArray = null
    this.branchList = null
    this.drsubsepceialList = null
    this.getarraydataList = null
    this.Fk_DoctorIdarray = null
    this.WeekDayIds = null
    this.schedulenniqeGroupList = null
    this.scheduleGroupList = null
    this.scheduleTypeList = null
    this.scheduleallList = null
    this.subsepceialList = null
    this.filterDrsubsepceialArray = null
  }

  openschedulemanagermodal() {
    document.getElementById("schedulemanagerModal").style.display = 'block';
  }

  closechedulemanagermodal() {
    document.getElementById("schedulemanagerModal").style.display = 'none';
    this.clearedata();
  }
  openscheduleextentionModal() {
    document.getElementById("scheduleextentionModal").style.display = 'block';
  }
  closescheduleextentionModal() {
    document.getElementById("scheduleextentionModal").style.display = 'none';
  }
  openbulkcancelModal() {
    document.getElementById("bulkcancelModal").style.display = 'block';
  }
  closebulkcancelModal() {
    document.getElementById("bulkcancelModal").style.display = 'none';
  }
  openeditcolumnModal() {
    document.getElementById("editColumnWiseModal").style.display = 'block';
  }
  closeEditColumnWiseModal() {
    document.getElementById("editColumnWiseModal").style.display = 'none';
    this.selectedColumnName = '';
    // this.selectedType = '';
    this.inputValue = '';
  }
  openscheduleMaster(): void {
    const dialogRef = this.dialog.open(ScheduleTypeMasterComponent, {
      width: '800px',
      height: 'auto',
      maxHeight: '40vh',
      data: {
        id: 1,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }
}
